// src/utils/gameConstants.js
const MECHANICS = [
"Acting, Singing, Trivia",
"Action Drafting",  
"Action Points",  
"Area Majority",  
"Auction / Bidding",  
"Betting and Bluffing",
"Dexterity",
"Drafting",
"Campaign", 
"Cooperative Game",  
"Deck, Bag, and Pool Building",  
"Deduction",
"Dexterity",  
"Dice Rolling",  
"Grid Movement",  
"Hand Management",  
"Hidden Movement",  
"Hidden Roles",  
"Legacy Game",
"Market",  
"Negotiation",  
"Network and Route Building",
"Patterns",
"Push Your Luck", 
"Rondel",
"Set Collection",
"Tile Placement",
"Trick-taking",  
"Worker Placement"
];

const MECHANIC_SYNONYMS = {
  'Dexterity': ['Flicking', 'Stacking'],
  'Patterns': ['Pattern Building','Pattern Movement','Pattern Recognition'],
  'Market': ['Loans', 'Market', 'Investment'],
  'Deck, Bag, and Pool Building': ['Deck Construction'],
  'Trick-taking':['Melding and Splaying'],
  'Campaign':['Scenario / Mission / Campaign Game'],
  'Acting, Singing, Trivia':['Acting', 'Singing', 'Drawing', 'Question and Answer']
};

const THEMES = [
"Abstract Strategy",
"Adventure",
"Age of Reason",
"American West",
"Ancient",
"Animals",
"Arabian",
"Aviation / Flight",
"Bluffing",
"Card Game",
"City Building",
"Civil War",
"Civilization",
"Collectible Components",
"Comic Book / Strip",
"Deduction",
"Economic",
"Educational",
"Electronic",
"Environmental",
"Exploration",
"Fantasy",
"Farming",
"Fighting",
"Horror",
"Humor",
"Industry / Manufacturing",
"Kids",
"Licensed (movie, video game)",
"Mafia",
"Math",
"Mature / Adult",
"Maze",
"Medical",
"Medieval",
"Memory",
"Miniatures",
"Murder / Mystery",
"Music",
"Mythology",
"Napoleonic",
"Nautical",
"Negotiation",
"Number",
"Party Game",
"Pike and Shot",
"Pirates",
"Political",
"Post-Napoleonic",
"Prehistoric",
"Print & Play",
"Puzzle",
"Racing",
"Real-time",
"Religious",
"Renaissance",
"Science Fiction",
"Space Exploration",
"Spies / Secret Agents",
"Sports",
"Territory Building",
"Trains",
"Transportation",
"Travel",
"Trivia",
"War",
"Word Game",
"Zombies"
];

const THEME_SYNONYMS = {
  'Abstract Strategy': ['Abstract'],
  'Adventure': ['Quest', 'Adventure Game'],
  'Fantasy': ['Medieval Fantasy', 'High Fantasy'],
  'Science Fiction': ['Sci-Fi', 'Sci Fi'],
  'Card Game': ['Card Based', 'Card-Based'],
  'Children\'s Game': ['Kids Game', 'Family Game'],
  'Horror': ['Scary', 'Creepy', 'Terror'],
  'Miniatures': ['Minis', 'Miniature Games'],
  'Party Game': ['Party', 'Social', 'Group Game'],
  'Sports': ['Sport', 'Athletics'],
  'Zombies': ['Zombie', 'Undead'],
  'Pirates': ['Pirate'],
  'Space Exploration': ['Space', 'Outer Space'],
  'War': ['Wargame', 'Civil War', 'World War', 'Vietnam War', 'Korean War', 'Warfare', 'Military', 'Combat', 'Warfare'],
  'City Building': ['City Builder', 'Urban Development'],
  'Civilization': ['Civ', 'Civilization Builder'],
  'Exploration': ['Explore', 'Discovery'],
  'kids':['Children\'s Game'],
  'Licensed (movie, video game)':['Movies', 'TV', 'Radio', 'Novel', 'Book', 'Video Game']


};

module.exports = { MECHANICS, MECHANIC_SYNONYMS, THEMES, THEME_SYNONYMS };